import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  const handleCheckout = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <section className="py-24 bg-holistic-earth text-center relative overflow-hidden" data-id="element-48">
      <div className="absolute inset-0 opacity-20" style={{
      backgroundImage: 'radial-gradient(#C5A059 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-49"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-50">
        <FadeIn data-id="element-51">
          <h2 className="text-3xl md:text-5xl font-serif text-holistic-cream mb-8 leading-tight" data-id="element-52">
            Solo hay dos caminos:
          </h2>
          <p className="text-xl md:text-2xl text-holistic-sand/90 mb-12 leading-relaxed font-light" data-id="element-53">
            Seguir tapando el sol con las manos (y los síntomas con pastillas) o
            tomar la decisión de descodificar tu cuerpo y sanar de verdad.
          </p>

          <div className="bg-holistic-sage/20 border border-holistic-sage/30 p-6 rounded-2xl inline-block mb-12 backdrop-blur-sm" data-id="element-54">
            <p className="text-2xl font-bold text-holistic-gold-light tracking-wide uppercase" data-id="element-55">
              Tu salud no puede esperar.
            </p>
          </div>

          <div data-id="element-56">
            <Button size="lg" variant="primary" onClick={handleCheckout} className="w-full sm:w-auto text-lg px-10 group shadow-xl shadow-holistic-wine/20" data-id="element-57">
              ¡SÍ! QUIERO MI ACCESO INMEDIATO
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-58" />
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}